import { render, staticRenderFns } from "./TrendingTopicsContainer.vue?vue&type=template&id=3f7acefb&scoped=true&"
import script from "./TrendingTopicsContainer.vue?vue&type=script&lang=js&"
export * from "./TrendingTopicsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TrendingTopicsContainer.vue?vue&type=style&index=0&id=3f7acefb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7acefb",
  null
  
)

export default component.exports